<div [class]="classPrefix('MainPod')">
  <card-one [props]="containerCard" [class]="classPrefix('Pod0')">
    <p [class]="classPrefix('Pod0Text0')" >{{"TransferRecipientsFormZero.subtitle" | translate}}</p>
    <wml-form-zero
    [class]="classPrefix('Pod0Form0')"
    [props]="mainForm"></wml-form-zero>
  </card-one>
</div>
